import React from 'react';

import { translate } from '~l10n/client';
import { Row } from 'react-table';

import { ActionButtons } from '~shared/components/ActionButtons';
import { Action } from '~shared/components/ActionMenu';
import { IconButton } from '~shared/components/buttons';
import { Container } from '~shared/components/Container';
import { IconX } from '~shared/components/icons/standard';
import { WorkspaceItem } from '~teacher/hook/workspaces/useWorkspaceItems';

interface Props {
  selectedRows: Array<Row<WorkspaceItem>>;
  actions: Array<Action<WorkspaceItem>>;
  toggleAllRows: (toToggle: boolean) => void;
}

export function WorkspaceItemTableFloatingActions({
  selectedRows,
  actions,
  toggleAllRows,
}: Props) {
  if (selectedRows.length <= 0) {
    return null;
  }
  return (
    <div
      className={'sticky z-101 bg-white rounded-6 shadow-modal py-2 px-5 h-16'}
      style={{ bottom: '20px' }}
    >
      <Container row>
        <Container row width={1}>
          <ActionButtons
            actions={actions}
            data={selectedRows.map((i) => i.original)}
          />
        </Container>
        <Container row className={'text-sm whitespace-no-wrap'} verticalCenter>
          <span className={'mr-3 text-blue-900'}>
            {translate('{0} selected').format(selectedRows.length)}
          </span>
          <IconButton
            onClick={() => {
              toggleAllRows(false);
            }}
          >
            <IconX />
          </IconButton>
        </Container>
      </Container>
    </div>
  );
}
